module.exports = __webpack_public_path__ + "img/black-eyed-pea-patties.488cd148.jpg";